import { redirect } from "react-router-dom";
import { API_BASE_URL } from "../config";

export const logoutAction = async () => {
  const token = localStorage.getItem("token");

  const response = await fetch(`${API_BASE_URL}/logout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const result = response.json();

  if (!response.ok) {
    return { error: result.message || "Logout failed. Please try again." };
  }

  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("approved");
  localStorage.removeItem("id");
  localStorage.removeItem("avatar");
  localStorage.removeItem("login_time");

  return redirect("/");
};

export const logoutActionAdmin = async () => {
  const token = localStorage.getItem("admin_token");

  const response = await fetch(`${API_BASE_URL}/admin/logout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const result = response.json();

  if (!response.ok) {
    return { error: result.message || "Logout failed. Please try again." };
  }

  localStorage.removeItem("admin_token");
  localStorage.removeItem("admin_id");
  localStorage.removeItem("admin_role");
  localStorage.removeItem("admin_login_time");

  return redirect("/admin/login");
};
